export default "  <div class=\"w-100 scroll-tmt-nav\">\n   <img [src]=\"data.img\" class=\"w-100\">\n  </div>"